<template>
  <div>
    <el-form label-width="80px">
      <div>
        <el-form-item label="Quantity">
          <el-input-number v-model="orgBattery.batteryQuantity"
                           size="small"
                           step-strictly
                           :min="0" />
        </el-form-item>
        <el-form-item label="Ship date">
          <el-date-picker v-model="orgBattery.batteryShipDate"
                          class="d-block w-100"
                          value-format="yyyy-MM-dd"
                          format="dd/MM/yyyy"
                          type="date"
                          placeholder="Set ship date" />
        </el-form-item>
        <el-form-item label="Comments">
          <el-input type="textarea"
                    :rows="2"
                    placeholder="Type your comments here"
                    v-model="orgBattery.batteryComments" />
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import { Checkbox, DatePicker, Form, FormItem, Input, InputNumber, Option, Select } from 'element-ui';
import { OrganisationBatteryModel } from '@/models/organisation/organisationBattery';

export default {
  name: 'form-new-org-battery',
  props: {
    orgBattery: {
      type: OrganisationBatteryModel,
      required: true
    }
  },
  components: {
    [Checkbox.name]: Checkbox,
    [DatePicker.name]: DatePicker,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [InputNumber.name]: InputNumber,
    [Option.name]: Option,
    [Select.name]: Select,
  },
  data() {
    return {
    }
  },
};
</script>